let reviews = [
  {
    customer_name: 'Esthela Prieto',
    customer_email: 'es2017prieto@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Greatful',
    rating: 5,
    created_at: '2022-10-02 22:53:12',
    published: 1,
    title: '',
    reply: '¡Gracias Esthela!',
    images: '',
  },
  {
    customer_name: 'Ana Sofía Romero',
    customer_email: 'sofiaromsal@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Me encanto el rocket man! Me sentí súper bien y salí deshinchada',
    rating: 5,
    created_at: '2022-10-08 20:59:56',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Bárbara FACER',
    customer_email: 'barbara@facer.mx',
    product_id: 4591816409153,
    product_handle: 'rocket-man-gift-card',
    body: 'Súper completo y lo máximo en general, obvio regresaré',
    rating: 5,
    created_at: '2022-10-10 14:43:27',
    published: 1,
    title: '',
    reply: '',
    images: 'https://img6.socialshopwave.com/client113183/recommendimages/recommend3_m634430d663f12.jpeg',
  },
  {
    customer_name: 'Oriela Medellin',
    customer_email: 'orielam@me.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Love the  technique it is also super relaxing',
    rating: 5,
    created_at: '2022-10-10 23:03:22',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Ericka Valdez',
    customer_email: 'kika.esv@gmail.com',
    product_id: 7731431309532,
    product_handle: 'higher-power-pos-1',
    body: 'El servicio y tratamiento excelente, vuelvo seguro',
    rating: 5,
    created_at: '2022-10-28 00:48:34',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Margarita Castilla',
    customer_email: 'margaritadeescalante@gmail.com',
    product_id: 4591816835137,
    product_handle: 'big-bang-gift-card',
    body: 'Great',
    rating: 5,
    created_at: '2022-11-02 07:36:14',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Ana Andrade',
    customer_email: 'i.living.london@gmail.com',
    product_id: 4558338785345,
    product_handle: 'gold-roller',
    body: 'I like the gold roller. I will use everyday!!',
    rating: 5,
    created_at: '2022-11-09 21:48:04',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Zuriñe Eguia',
    customer_email: 'zuribeeguia@hotmail.com',
    product_id: 7446758916316,
    product_handle: '45-membership-buen-fin',
    body: 'Me encanto el servicio y el producto!',
    rating: 5,
    created_at: '2022-11-17 18:08:53',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Cristina Gutierrez',
    customer_email: 'cristina_gtz@hotmail.com',
    product_id: 4591816409153,
    product_handle: 'rocket-man-gift-card',
    body: 'No sabía que esperar , era la primera vez que iba y me encanto ! Muy recomendable!',
    rating: 5,
    created_at: '2022-11-23 04:34:06',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Ana Paula Ruiz',
    customer_email: '97anapaularuiz@gmail.com',
    product_id: 7731431309532,
    product_handle: 'higher-power-pos-1',
    body: 'Me encanto',
    rating: 5,
    created_at: '2022-11-25 14:10:25',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Adriel Mencia',
    customer_email: 'mencia0424@gmail.com',
    product_id: 7019172659374,
    product_handle: 'make-it-your-own-online',
    body: 'THANKS THE SERVER GREAT AND THE PERSONAL PROFESSIONAL',
    rating: 5,
    created_at: '2022-11-29 18:17:26',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'FACER',
    customer_email: 'info@facer.mx',
    product_id: 4487660503105,
    product_handle: 'eclip-c',
    body: 'Amoooo',
    rating: 5,
    created_at: '2022-12-08 01:33:45',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'valeria',
    customer_email: 'valeriatafichl@gmail.com',
    product_id: 4488098709569,
    product_handle: 'aceite-estelar-lemongrass',
    body: 'Me dejo la piel muy suave y lisa',
    rating: 5,
    created_at: '2022-12-16 00:52:23',
    published: 0,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Bárbara FACER',
    customer_email: 'barbara@facer.mx',
    product_id: 4488382251073,
    product_handle: 'crema-cosmica',
    body: 'Me encanta que es super hidratante y ligera al mismo tiempo.',
    rating: 5,
    created_at: '2022-12-18 21:27:51',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Jose Pablo Torres Reyes',
    customer_email: 'josepablot@hotmail.com',
    product_id: 4591816409153,
    product_handle: 'rocket-man-gift-card',
    body: 'Soy bastante fan de facer y más de este ejercicio! Dura casi 1 hora y siempre salgo con la cara renovada. Bastante recomendado para sentirte más liviano.',
    rating: 5,
    created_at: '2022-12-19 18:11:04',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Anonym',
    customer_email: '',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Excelente servicio y atención de LETY!',
    rating: 5,
    created_at: '2022-12-29 00:31:13',
    published: 0,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: '',
    customer_email: 'samanta.camarillo@me.com',
    product_id: 4591610658881,
    product_handle: 'big-bang',
    body: 'Muy placentera, inicio de cita puntual, buena comunicación con la persona que me atendió, muy profesional.',
    rating: 5,
    created_at: '2023-01-05 00:51:18',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Sofia Catalina Martinez',
    customer_email: 'catymtz0808@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Increíble experiencia',
    rating: 5,
    created_at: '2023-01-06 17:05:00',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Rosy Teran',
    customer_email: 'rgtl12@hotmail.com',
    product_id: 7017809477806,
    product_handle: '45-membership-online',
    body: 'Great',
    rating: 5,
    created_at: '2023-01-09 21:47:51',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Araceli Perez',
    customer_email: 'aripg.perez@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Experiencia mágica! Lo super recomiendo! Israel es el mejor.',
    rating: 5,
    created_at: '2023-01-14 03:15:26',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'FACER',
    customer_email: 'info@facer.mx',
    product_id: 4558337376321,
    product_handle: 'black-obsidian-gua-sha',
    body: 'Desde que empece a usar mi gua sha, he visto cambios impresionantes en mi piel.',
    rating: 5,
    created_at: '2023-01-17 18:08:26',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Janny Druckr',
    customer_email: 'jshaooli@gmail.com',
    product_id: 4591124250689,
    product_handle: 'power-up',
    body: 'Estuvo súper rico y relajante',
    rating: 5,
    created_at: '2023-02-02 18:55:09',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Adrian Canavati Santos',
    customer_email: 'adriancanavati@gmail.com',
    product_id: 4591124250689,
    product_handle: 'power-up',
    body: 'Excelente y me ayudo mucho con presión que tenia en la frente.',
    rating: 5,
    created_at: '2023-02-05 03:20:19',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Elizabeth Briseño',
    customer_email: 'elizabetbriseno@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Todo excelente',
    rating: 5,
    created_at: '2023-02-09 07:06:04',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Carolina Sada de Pro',
    customer_email: 'carosadag@gmail.com',
    product_id: 4591610658881,
    product_handle: 'big-bang',
    body: 'Si ayuda el tratamiento a humectar la piel!!',
    rating: 5,
    created_at: '2023-02-09 14:17:59',
    published: 1,
    title: '',
    reply: '',
    images: 'https://img7.socialshopwave.com/client113183/recommendimages/recommend26_m63e50097abcf4.jpeg',
  },
  {
    customer_name: 'Ximena Richardson',
    customer_email: 'ximerichardson@gmail.com',
    product_id: 4488382251073,
    product_handle: 'crema-cosmica',
    body: 'La mejor crema. Me encanta ponermela de noche!',
    rating: 5,
    created_at: '2023-02-10 23:07:12',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Juan manuel Gonzalez',
    customer_email: 'juanmgzz@gmail.com',
    product_id: 4591610658881,
    product_handle: 'big-bang',
    body: 'It was amazing!',
    rating: 5,
    created_at: '2023-02-11 20:02:12',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Michelle Aguilar',
    customer_email: 'michellepattz@icloud.com',
    product_id: 4486196920385,
    product_handle: 'jabon-atomico',
    body: 'Me encanta, tiene un olor súper freso y deja la piel deliciosa.',
    rating: 5,
    created_at: '2023-02-21 20:49:05',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Jose Luis Ceballos',
    customer_email: 'jlceballos@grupodam.mx',
    product_id: 4591816409153,
    product_handle: 'rocket-man-gift-card',
    body: 'Excelente, super recomendable.',
    rating: 5,
    created_at: '2023-02-24 18:59:27',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Montserrat Dipp',
    customer_email: 'montserratdipp@hotmail.com',
    product_id: 0,
    product_handle: '',
    body: 'Power up workout  \n\nSon 30 minutos que te dejan la cara luciendo perfecta!! Ojos súper desinflamados, la mirada cambia por completo!',
    rating: 5,
    created_at: '2023-02-26 13:38:51',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Michelle Aguilar',
    customer_email: 'michellepattz@icloud.com',
    product_id: 4488080851009,
    product_handle: 'aceite-estelar-lavanda',
    body: 'Mi aceite favorito, tiene un olor muy rico y deja la piel muy suave. 🤍',
    rating: 5,
    created_at: '2023-03-15 20:04:47',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Michelle Aguilar',
    customer_email: 'michellepattz@icloud.com',
    product_id: 4487623049281,
    product_handle: 'ultra-tonico',
    body: 'Amo su olor a Rosas! Lo uso todos los días.',
    rating: 5,
    created_at: '2023-03-15 20:05:24',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Michelle Aguilar',
    customer_email: 'michellepattz@icloud.com',
    product_id: 4488382251073,
    product_handle: 'crema-cosmica',
    body: 'Es mi crema favorita, amo los productos de la línea de facer y me gusta que son naturales. Muy recomendado.',
    rating: 5,
    created_at: '2023-03-15 20:06:06',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Michelle Aguilar',
    customer_email: 'michellepattz@icloud.com',
    product_id: 6555991113902,
    product_handle: 'facer-micro-roller',
    body: 'Me ayuda a trabajar la tensión que tengo en mis músculos de la cara.',
    rating: 5,
    created_at: '2023-03-15 20:06:51',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Raquel Franco',
    customer_email: 'raquelfranco178@outlook.com',
    product_id: 4558338785345,
    product_handle: 'gold-roller',
    body: 'Muy bueno \nMe encantó',
    rating: 5,
    created_at: '2023-03-24 03:56:54',
    published: 1,
    title: '',
    reply: '¡Gracias!',
    images: '',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 7731427999964,
    product_handle: 'higher-power-1',
    body: 'loooooove',
    rating: 5,
    created_at: '2023-03-28 20:35:53',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Samantha Pedraza',
    customer_email: 'samantha_pe@icloud.com',
    product_id: 0,
    product_handle: '',
    body: 'ROCKETMAN 💆‍♀️\nFue mi primer workout de FACER, amé.\nDesde el inicio me explicaron cada paso conforme se iba avanzando.\nEl servicio y la atención es top!',
    rating: 5,
    created_at: '2023-05-09 03:59:34',
    published: 1,
    title: '',
    reply: '¡Gracias por tu review Samantha! Esperamos que así siempre sea tu experiencia con nosotros.',
    images: '',
  },
  {
    customer_name: 'Ximena Richardson',
    customer_email: 'ximerichardson@gmail.com',
    product_id: 4487623049281,
    product_handle: 'ultra-tonico',
    body: 'Me encanta su olor, su textura y definitvamente es mi must en la rutina de noche!',
    rating: 5,
    created_at: '2023-05-10 02:48:42',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Michelle Aguilar',
    customer_email: 'michellepattz@icloud.com',
    product_id: 0,
    product_handle: '',
    body: 'Los mejores workouts en todo Mexico y los mejores productos.',
    rating: 5,
    created_at: '2023-05-30 00:41:44',
    published: 1,
    title: '',
    reply: '',
    images:
      'https://img0.socialshopwave.com/client113183/recommendimages/recommend40_m647546486bca6.jpeg, https://img2.socialshopwave.com/client113183/recommendimages/recommend40_m647546493f807.jpeg',
  },
  {
    customer_name: 'Bárbara FACER',
    customer_email: 'barbara@facer.mx',
    product_id: 4487660503105,
    product_handle: 'eclip-c',
    body: 'Me encanta esta formula nueva, sus efectos se notan mucho más rápido!',
    rating: 5,
    created_at: '2023-07-20 15:59:12',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Daniela godoy',
    customer_email: 'duzacbrand@gmail.com',
    product_id: 4487660503105,
    product_handle: 'eclip-c',
    body: 'Me encanto! Lo sentí increíble y mi piel quedó hermosa! Súper recomendado',
    rating: 5,
    created_at: '2023-08-09 03:46:46',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Ariana Mena',
    customer_email: 'ari.mg84@gmail.com',
    product_id: 0,
    product_handle: '',
    body: 'Excelente en mi primer sesión',
    rating: 5,
    created_at: '2023-08-21 01:52:07',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Martha Martinez',
    customer_email: 'mpme4@hotmail.com',
    product_id: 0,
    product_handle: '',
    body: 'Una gran experiencia disfrutar de sus servicios, me relaja y me consiento,  realmente muy recomendable, gracias',
    rating: 5,
    created_at: '2023-08-25 01:57:46',
    published: 1,
    title: '',
    reply: 'gracias Martha, te esperamos de regreso pronto!',
    images: '',
  },
  {
    customer_name: 'Elpidio Bojorquez',
    customer_email: 'elpidiobojorquez@gmail.com',
    product_id: 0,
    product_handle: '',
    body: 'El mejor lugar para faceworkout',
    rating: 5,
    created_at: '2023-12-02 21:01:36',
    published: 1,
    title: '',
    reply: 'wow! gracias por compartir!',
    images: 'https://img8.socialshopwave.com/client113183/recommendimages/recommend45_m656b9b30aa20e.jpeg',
  },
  {
    customer_name: 'Elpidio Bojorquez',
    customer_email: 'elpidiobojorquez@gmail.com',
    product_id: 4591816409153,
    product_handle: 'rocket-man-gift-card',
    body: '⭐️⭐️⭐️⭐️⭐️',
    rating: 5,
    created_at: '2023-12-09 00:51:53',
    published: 1,
    title: '',
    reply: 'gracias Elpidio, te esperamos te regreso pronto!',
    images: '',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 8138564534492,
    product_handle: 'solar-shield',
    body: 'Me encanta! Super practico de usar y tener conmigo todo el tiempo',
    rating: 5,
    created_at: '2024-01-08 19:28:33',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 4591817588801,
    product_handle: 'quick-power-1',
    body: 'excelente para cuando tienes poco tiempo pero quieres algo efectivo, me encanta!',
    rating: 5,
    created_at: '2024-01-11 15:17:39',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Monica Flores',
    customer_email: 'monica.floresc@gmail.com',
    product_id: 4591124250689,
    product_handle: 'power-up',
    body: 'Se me hizo muy caro para lo que fue, de igual forma lo disfrute mucho pero creo que no volveré',
    rating: 5,
    created_at: '2024-01-12 02:03:08',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Adriana casillas Álvarez',
    customer_email: 'acasilla@up.edu.mx',
    product_id: 4591124250689,
    product_handle: 'power-up',
    body: 'Great experience!!! Esmeralda the person who attendent me was amazing!! You can see the results inmediately',
    rating: 5,
    created_at: '2024-01-12 15:13:31',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Laura Vasquez',
    customer_email: 'vazsalgadolaura@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Muchas Gracias excelente atención',
    rating: 5,
    created_at: '2024-01-19 00:54:12',
    published: 1,
    title: '',
    reply: '',
    images: 'https://img6.socialshopwave.com/client113183/recommendimages/recommend51_m65a9c8343800d.jpeg',
  },
  {
    customer_name: 'Elpidio Bojorquez',
    customer_email: 'elpidiobojorquez@gmail.com',
    product_id: 7019172659374,
    product_handle: 'make-it-your-own-online',
    body: '100% recomendado',
    rating: 5,
    created_at: '2024-02-06 22:57:48',
    published: 1,
    title: '',
    reply: 'gracias por el comentario Elpidio!',
    images: '',
  },
  {
    customer_name: 'Elpidio Bojorquez',
    customer_email: 'elpidiobojorquez@gmail.com',
    product_id: 4558337376321,
    product_handle: 'black-obsidian-gua-sha',
    body: 'Best tool',
    rating: 5,
    created_at: '2024-02-06 22:57:56',
    published: 1,
    title: '',
    reply: 'que bueno que te gustó!!',
    images: '',
  },
  {
    customer_name: 'Elpidio Bojorquez',
    customer_email: 'elpidiobojorquez@gmail.com',
    product_id: 7017809477806,
    product_handle: '45-membership-online',
    body: 'Best place in mx',
    rating: 5,
    created_at: '2024-02-06 22:58:09',
    published: 1,
    title: '',
    reply: 'gracias!!!',
    images: '',
  },
  {
    customer_name: 'Abigail Aguilar Garcia',
    customer_email: 'abigail.aguila.11@gmail.com',
    product_id: 4487623049281,
    product_handle: 'ultra-tonico',
    body: 'Excelentes productos muchas gracias',
    rating: 5,
    created_at: '2024-02-09 19:52:02',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Berenice Mejía',
    customer_email: 'pcym0212@gmail.com',
    product_id: 7019172659374,
    product_handle: 'make-it-your-own-online',
    body: 'La mejor inversión para mi 🥰 me encanta ir a mis faciales con Isra y Lili. Mi favorito es el Rocket Man.',
    rating: 5,
    created_at: '2024-02-12 21:13:21',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Berenice Mejía',
    customer_email: 'pcym0212@gmail.com',
    product_id: 4558338785345,
    product_handle: 'gold-roller',
    body: '¡Me encanta! Lo uso casi todas las noches como seguimiento a mis faciales, así termino relajada y lista para dormir.',
    rating: 5,
    created_at: '2024-02-12 21:14:25',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Berenice Mejía',
    customer_email: 'pcym0212@gmail.com',
    product_id: 4488080851009,
    product_handle: 'aceite-estelar-lavanda',
    body: 'Amo su olor, lo uso día y noche después del tónico y antes de la crema. Me deja la piel muy hidratada y con luminosidad.',
    rating: 5,
    created_at: '2024-02-12 21:15:34',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Jimena Meza',
    customer_email: 'jimenamm95@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Lilia es la mejor!!! El trato es excelente, los resultados son impresionantes',
    rating: 5,
    created_at: '2024-02-23 02:46:20',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'EFREN LOZANO',
    customer_email: 'itsefrench@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Super relajante, lo disfruté mucho.',
    rating: 5,
    created_at: '2024-03-11 04:36:43',
    published: 1,
    title: '',
    reply: '',
    images:
      'https://img8.socialshopwave.com/client113183/recommendimages/recommend60_m65ee8a5be4f0a.jpeg, https://img1.socialshopwave.com/client113183/recommendimages/recommend60_m65ee8a5cd5d17.jpeg',
  },
  {
    customer_name: 'Rita Berenice Leon Orozco',
    customer_email: 'rocke_rita@hotmail.es',
    product_id: 7019172659374,
    product_handle: 'make-it-your-own-online',
    body: 'Me encantan los resultados demi cara y piel. Además del trato 🩷',
    rating: 5,
    created_at: '2024-03-30 14:21:05',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Abigail Aguilar Garcia',
    customer_email: 'abigail.aguila.11@gmail.com',
    product_id: 4488068595777,
    product_handle: 'neoserum',
    body: 'Excelente producto 👍',
    rating: 5,
    created_at: '2024-03-30 16:24:47',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Ernesto ochoa',
    customer_email: 'ernestonet@gmail.com',
    product_id: 4591123890241,
    product_handle: 'quick-power',
    body: 'Muy buen servicio todo Ok',
    rating: 5,
    created_at: '2024-04-07 04:20:27',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Mayra Martinez',
    customer_email: 'mayramtz94@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Súper recomendado!! Nos encantó el facial Orbit Pull, sin duda volveremos de nuevo.',
    rating: 5,
    created_at: '2024-04-23 14:34:33',
    published: 1,
    title: '',
    reply: '¡gracias por visitarnos! nos vemos de regreso pronto 💘',
    images: 'https://img4.socialshopwave.com/client113183/recommendimages/recommend64_m6627c6f955ab4.jpg',
  },
  {
    customer_name: 'Karla Lozano',
    customer_email: 'karlilozano@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Buenisimo, gracias!',
    rating: 5,
    created_at: '2024-05-05 01:55:27',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Paulina Nieto',
    customer_email: 'mariapaunieto@gmail.com',
    product_id: 4591123890241,
    product_handle: 'quick-power',
    body: 'Me encantó',
    rating: 5,
    created_at: '2024-05-07 12:58:39',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Karla Lozano',
    customer_email: 'karlilozano@gmail.com',
    product_id: 4591816409153,
    product_handle: 'rocket-man-gift-card',
    body: 'Buenisimo',
    rating: 5,
    created_at: '2024-05-10 02:33:10',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Idaly Chibli',
    customer_email: 'idaly_ch@hotmail.com',
    product_id: 7017809477806,
    product_handle: '45-membership-online',
    body: 'Me encantó el servicio! Excelente Israel!',
    rating: 5,
    created_at: '2024-05-10 03:07:45',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Gabriela Garza',
    customer_email: 'gabrielagarzaguel@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Me encantó el servicio! Lo recomiendo ampliamente.',
    rating: 5,
    created_at: '2024-05-11 14:16:30',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Elpidio Bojorquez',
    customer_email: 'elpidiobojorquez@gmail.com',
    product_id: 4488098709569,
    product_handle: 'aceite-estelar-lemongrass',
    body: 'Excelente producto',
    rating: 5,
    created_at: '2024-05-11 21:23:36',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Luza Arizabalo',
    customer_email: 'arizabaloluza@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Lourdes es excelente. El mejor masaje facial que he tenido es con ella! Gracias',
    rating: 5,
    created_at: '2024-05-17 15:57:47',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: '',
    customer_email: 'ssantosv@me.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Siento la cara mas desinflamada y tonificada\nMuchas gracias Mónica!',
    rating: 5,
    created_at: '2024-05-24 03:14:59',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 4488068595777,
    product_handle: 'neoserum',
    body: 'es lo que más me ha ayudado a desvanecer manchitas de acné, lo aaaamoo',
    rating: 5,
    created_at: '2024-05-28 21:49:21',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Graciela Vargas',
    customer_email: 'lgvargaselizondo@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: 'Todo buenisimo. Servicio masaje todo todo. Solo recomiendo preguntar antes de aplicar bloqueador en spray o procurar aplicar bloqueador en crema. Tengo entendido que como yo, habemos gente que el bloqueador en spray nos provoca una alergia en los ojos de ardor muy feo. No lo senti hasta salir y es miy molesto. Fuera de eso todo padrisimo, mil gracias. 😊',
    rating: 5,
    created_at: '2024-06-08 13:42:35',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Martha Martinez',
    customer_email: 'mpme4@hotmail.com',
    product_id: 8571151319260,
    product_handle: 'booster-mascara-led',
    body: 'Excelentes resultados desde la primera vez de uso, gracias',
    rating: 5,
    created_at: '2024-06-10 03:06:27',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Marcela Treviño',
    customer_email: 'marcetrevinot@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Me encanto',
    rating: 5,
    created_at: '2024-06-11 15:10:50',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Marcela Treviño',
    customer_email: 'marcetrevinot@gmail.com',
    product_id: 4486196920385,
    product_handle: 'jabon-atomico',
    body: 'Me encanta',
    rating: 5,
    created_at: '2024-06-11 15:11:47',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 6108126838958,
    product_handle: 'orbit-pull-gift-card',
    body: 'El workout maaaas relajante, lo amo!',
    rating: 5,
    created_at: '2024-06-19 13:03:39',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'María José Hernandez Saro',
    customer_email: 'mariajose.hs@madebynature.mx',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Súper recomendado! Me lo hice durante el embarazo y me ayudo mucho a drenar y eliminar retención de líquidos.',
    rating: 5,
    created_at: '2024-07-02 08:55:34',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Alejandra Rodriguez',
    customer_email: 'aletrinidad333@gmail.com',
    product_id: 4591123890241,
    product_handle: 'quick-power',
    body: 'Rápido,  calmante y efectivo!\nGracias Lilia',
    rating: 5,
    created_at: '2024-07-06 05:01:23',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Maria Nava',
    customer_email: 'marialenavae@outlook.com',
    product_id: 4488098709569,
    product_handle: 'aceite-estelar-lemongrass',
    body: 'Deja la piel wow, super opcion para usar el guasha! Huele deli',
    rating: 5,
    created_at: '2024-07-11 18:54:24',
    published: 1,
    title: '',
    reply: 'es el mejor combo, y si el olor nos encanta!!!! gracias por compartir',
    images: '',
  },
  {
    customer_name: 'Maria Nava',
    customer_email: 'marialenavae@outlook.com',
    product_id: 4558337376321,
    product_handle: 'black-obsidian-gua-sha',
    body: 'Super buen material, facil de usar.',
    rating: 5,
    created_at: '2024-07-11 18:54:47',
    published: 1,
    title: '',
    reply: 'que bueno que te gusto!',
    images: '',
  },
  {
    customer_name: 'Marisol Gonzalez Pacheco',
    customer_email: 'marisolglez90@gmail.com',
    product_id: 7731431309532,
    product_handle: 'higher-power-pos-1',
    body: 'Excelente facial si buscas un refresh general, salí sintiéndome revitalizada de la cara, fresca y con la piel tensa para bien. Al día siguiente noté mucho más el cambio, recomiendo 100%',
    rating: 5,
    created_at: '2024-07-12 16:29:29',
    published: 1,
    title: '',
    reply: 'gracias por tu reseña Marisol, te esperamos de regreso pronto!',
    images: '',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 8658512445660,
    product_handle: 'eau-de-parfum-facer-x-perfumerica',
    body: 'Super fresco! Literalmente FACER en una botella 💘',
    rating: 5,
    created_at: '2024-07-15 14:46:59',
    published: 1,
    title: '',
    reply: '',
    images: 'https://img6.socialshopwave.com/client113183/recommendimages/recommend84_m6695366394bd0.jpeg',
  },
  {
    customer_name: 'Barbara Richardson',
    customer_email: 'brichardsont@gmail.com',
    product_id: 4486196920385,
    product_handle: 'jabon-atomico',
    body: 'Amo!',
    rating: 5,
    created_at: '2024-07-15 14:47:33',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Rita Glender',
    customer_email: 'ritagd@yahoo.com',
    product_id: 7019172659374,
    product_handle: 'make-it-your-own-online',
    body: 'My face changes inmediatly, it seems fresher and younger',
    rating: 5,
    created_at: '2024-08-17 00:16:55',
    published: 1,
    title: '',
    reply: 'gracias Rita! nos encanta recibirte siempre!',
    images: '',
  },
  {
    customer_name: 'Gabriela Martinez',
    customer_email: 'gabii_mttz@hotmail.com',
    product_id: 7017809477806,
    product_handle: '45-membership-online',
    body: 'Excelente',
    rating: 5,
    created_at: '2024-09-02 23:43:04',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Leny Fasci',
    customer_email: 'leny.fasci@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Fue demasiado relajante y el cambio se vio inmediatamente en mi cara.',
    rating: 5,
    created_at: '2025-02-28 02:37:55',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Andrea Camacho',
    customer_email: 'andrealcn180@gmail.com',
    product_id: 4591610658881,
    product_handle: 'big-bang',
    body: 'Karina de FACER Santa Fe, es la mejor siempre voy con ella y me deja como nueva! 100% recomendado',
    rating: 5,
    created_at: '2025-03-01 21:15:48',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Andrea Camacho',
    customer_email: 'andrealcn180@gmail.com',
    product_id: 4591612428353,
    product_handle: 'rocket-man',
    body: '10/10 es un súper tratamiento me encantan los resultados',
    rating: 5,
    created_at: '2025-03-01 21:16:19',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Ana Paula Gonzalez Horn',
    customer_email: 'anapauglezhorn@gmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Lilia hizo un excelente trabajo. Muchísimas gracias!',
    rating: 5,
    created_at: '2025-03-03 02:04:58',
    published: 1,
    title: '',
    reply: '',
    images: '',
  },
  {
    customer_name: 'Martha Martinez',
    customer_email: 'mpme4@hotmail.com',
    product_id: 6076086124718,
    product_handle: 'orbit-pull',
    body: 'Gracias 🙏🏻 excelente servicio',
    rating: 5,
    created_at: '2025-03-20 02:36:05',
    published: 1,
    title: '',
    reply: '',
    images:
      'https://sswfiles.s3.amazonaws.com/production/113183/reviewsImages/gw-reviews-img-11e2762b-4bc7-4305-95a5-e8bd00c1fe88.jpeg',
  },
];

// Función para revolver array
function shuffleArray(array) {
  return array.sort(() => 0.5 - Math.random());
}

function handleToCamelCase(handle) {
  return handle
    .split('-') // separar por guiones
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // capitalizar cada palabra
    .join(' '); // unir todo con espacios
}

// Cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function () {
  const shuffledReviews = shuffleArray(reviews).slice(0, 8); // Tomamos 8 reviews random
  const wrapper = document.getElementById('reviews-wrapper');


  shuffledReviews.forEach((review) => {

    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');

    slide.innerHTML = `
        <div class="review-card">
          <h3 class="review-product"> ${handleToCamelCase(review.product_handle)}</h3>
          <p class="review-body">"${review.body}"</p>
          <p class="review-customer">- ${review.customer_name}</p>
          <p class="review-rating">${'⭐'.repeat(review.rating)}</p>
        </div>
      `;

    wrapper.appendChild(slide);
  });

  new Swiper('.reviews-swiper', {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next', // Selecciona el botón de "next"
      prevEl: '.swiper-button-prev', // Selecciona el botón de "prev"
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    }
  });

});